import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import SettingsIcon from '@material-ui/icons/Settings';

const styles = {
    styled: {
        position: 'relative',
        top: '3px',
        right: '5px',
        height: '20px',
        marginRight: '-5px',
    },
};

function GearIcon(props) {
    const { classes } = props;

    return <SettingsIcon className={classes.styled} aria-label="gear icon" />;
}

GearIcon.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(GearIcon);
